import Vue from "vue"
const ipReg =
  /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/

const defaultLang = "zh_HK"
// 语言映射对象
const langMap = {
  en: "en_US",
  "zh-hant": "zh_HK"
}

const dirMap = {
  0: "mpj",
  15: "wellcome"
}
const facebookId = {
  0: ""
}

const _setEnvVar = (key, value) => {
  if (process.server) {
    global.__env__[key] = value
  } else {
    window.__env__[key] = value
  }
  return value
}

const _getOrigin = req => {
  if (process.server) {
    const host = req.headers["x-forwarded-host"] || req.headers.host
    const protocol = ipReg.test(host) || host.includes("localhost") ? "http" : "https"
    return `${protocol}://${host}`
  }
  return window.location.origin
}
const _setDomainFlag = (req, store) => {
  if (process.server) {
    const domainFlag = req.headers["domain-flag"] || ""
    store.commit("setDomainFlag", domainFlag)
  }
}

export const setTenantId = ({ store }) => {
  _setEnvVar("tenantId", store.state.commonParams?.dmTenantId)
}

/**
 * 获取语言
 * @param {*} $cookies
 * @param {*} route
 * @returns
 */
const _getLang = ({ $cookies, route }) => {
  const match = route.path.match(/(en|zh-hant)/)
  if (match) {
    const [key] = match
    return langMap[key] || defaultLang
  }
  return $cookies.get("superweb-locale") || defaultLang
}

export const getEnv = () => {
  if (process.server) {
    return global.__env__
  } else {
    return window.__env__
  }
}

export const getLang = () => {
  const env = getEnv()
  return env?.lang
}

export const getTenantId = () => {
  const env = getEnv()
  return env?.tenantId
}
export const getDomainFlag = () => {
  const env = getEnv()
  return env?.domainFlag
}

export const getDomain = () => {
  const env = getEnv()
  return env?.domain
}

export const getPaths = () => {
  const env = getEnv()
  return env?.paths || {}
}

export const getCommonReqParam = () => {
  const env = getEnv()
  return env?.commonReqParams || {}
}

export const getCommonParam = () => {
  const env = getEnv()
  return env?.commonParam || {}
}

export const getIsOnline = () => {
  const env = getEnv()
  return env?.isOnline
}

export const setIsOnline = isOnline => {
  _setEnvVar("isOnline", isOnline)
}

export const getAid = () => {
  const env = getEnv()
  return env?.aid
}

export const setAid = aid => {
  _setEnvVar("aid", aid)
}

export const getLocaleKey = lang => {
  const entry = Object.entries(langMap).find(([_, value]) => value === lang)
  return entry ? entry[0] : null
}

export const getTenantDir = _ => {
  const tenantId = getTenantId()
  return dirMap[tenantId] || "wellcome"
}

export const setCommonReqParam = ({ store }) => {
  const { commonParams } = store.state
  return _setEnvVar("commonReqParams", {
    ...getCommonParam(),
    areaId: "",
    brandId: "",
    categorySkuId: 0,
    bannerId: "5,6",
    deliveryLat: commonParams?.deliveryLat || "",
    deliveryLng: commonParams?.deliveryLng || ""
  })
}

export const setCommonParam = ({ store, $cookies }) => {
  const { commonParams, resCookies } = store.state
  return _setEnvVar("commonParam", {
    dmTenantId: commonParams.dmTenantId,
    venderId: $cookies.get("venderId") || commonParams.venderId,
    businessCode: 1,
    origin: 26, // 27 for h5, 26 for pc
    "superweb-locale": getLang(),
    storeId: resCookies?.storeId || $cookies.get("store") || commonParams.storeId,
    pickUpStoreId: $cookies.get("pickUpStoreId") || store.state.commonParams.pickUpStoreId,
    shipmentType: $cookies.get("shipmentType") || store.state.commonParams.shipmentType // 配送方式：1-送货，2-自提
  })
}

export const setLang = ({ store, $cookies, lang }) => {
  $cookies.set("superweb-locale", lang, { httpOnly: false })
  store.commit("setLang", lang)
}

export default ({ req, route, store, $cookies }) => {
  // 根据环境设置域名
  const domain = process.server ? req.headers["x-forwarded-host"] || req.headers.host : window.location.host
  const origin = _getOrigin(req)
  const lang = _getLang({ $cookies, route })

  // 设置 MAIN_PATH 和 MAIN_ORIGIN 等环境变量
  let MAIN_PATH = ""
  let MAIN_PATH_WITHOUT_LANG = ""
  const MAIN_ORIGIN = origin
  const MAIN_ORIGIN_HOME = origin

  if ((domain.includes(".rta-os.com") && !domain.includes("mpjweb")) || domain.includes("shop.yuu.hk")) {
    MAIN_PATH_WITHOUT_LANG = "/wellcome"
  }

  if (ipReg.test(domain) || domain === "localhost") {
    MAIN_PATH = MAIN_PATH_WITHOUT_LANG
  } else if (lang === "zh_HK") {
    MAIN_PATH = "/zh-hant" + MAIN_PATH_WITHOUT_LANG
  } else if (lang === "en_US") {
    MAIN_PATH = "/en" + MAIN_PATH_WITHOUT_LANG
  }
  // 網站區分
  _setDomainFlag(req, store)
  setLang({ store, $cookies, lang })

  // 将环境变量注入 Vue 实例
  Vue.prototype.MAIN_PATH = MAIN_PATH
  Vue.prototype.MAIN_PATH_WITHOUT_LANG = MAIN_PATH_WITHOUT_LANG
  Vue.prototype.MAIN_ORIGIN_HOME = MAIN_ORIGIN_HOME
  Vue.prototype.MAIN_ORIGIN = MAIN_ORIGIN
  const domainFlag = store.state.domainFlag
  const isOnline = store.state.isOnline
  const aid = store.state.aid
  global.__env__ = {
    domain,
    lang,
    tenantId: 15,
    domainFlag,
    commonParam: {},
    commonReqParams: {},
    paths: {
      MAIN_PATH,
      MAIN_PATH_WITHOUT_LANG,
      MAIN_ORIGIN_HOME,
      MAIN_ORIGIN
    },
    isOnline,
    aid
  }
}
